import { render, staticRenderFns } from "./content-menu-editor-desktop.vue?vue&type=template&id=172a16f4"
import script from "./content-menu-editor-desktop.vue?vue&type=script&lang=js"
export * from "./content-menu-editor-desktop.vue?vue&type=script&lang=js"
import style0 from "./content-menu-editor-desktop.vue?vue&type=style&index=0&id=172a16f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports